import { getClientPath, isEmptyObject, isInGameBrowser, isMobileOrTabletWindow } from '~/utils/utils';
import styles from './FullScreenBackgroundWithMask.scss';
import { useState } from 'react';
import classNames from 'classnames';

interface IFullScreenBlurMask {
    backgroundColor?: string;
    backgroundImage: string;
    backgroundVideo?: IVideo;
}

const FullScreenBackgroundWithMask = ({ backgroundImage, backgroundColor, backgroundVideo }: IFullScreenBlurMask) => {
    const [isLoadedVideo, setLoadVideo] = useState(false);

    const stylesProperties = {
        '--background-color': backgroundColor || 'transparent',
        '--background-image': `url(${backgroundImage})`,
    } as React.CSSProperties;

    const classesVideoWrapper = classNames(styles.videoWrapper, {
        [styles.show]: isLoadedVideo,
    });

    return (
        <div className={styles.wrapper} style={stylesProperties}>
            <div className={styles.bluredBackground}></div>
            <div className={styles.fullScreenBlurMask}>
                <div className={styles.background} />
                <div className={classesVideoWrapper}>
                    {!isMobileOrTabletWindow && !isEmptyObject(backgroundVideo) && (
                        <div className={styles.videoBackground}>
                            <video
                                autoPlay
                                loop
                                muted
                                preload={'metadata'}
                                playsInline
                                onLoadedData={() => {
                                    setLoadVideo(true);
                                }}
                            >
                                {!!backgroundVideo?.clientVideoName?.trim().length && isInGameBrowser && (
                                    <source type={'video/webm'} src={getClientPath(`armory/${backgroundVideo.clientVideoName}`)} />
                                )}
                                <source src={backgroundVideo.webm} type="video/webm" />
                                <source src={backgroundVideo.mp4} type="video/mp4" />
                            </video>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FullScreenBackgroundWithMask;
